import { SET_BREADCRUMB_ROUTES } from '../reducers/breadcrumbReducer';

export const setBreadcrumbRoutes = (routes: any[]) => ({
  type: SET_BREADCRUMB_ROUTES,
  payload: routes,
}); 